import { useEffect, useState, useRef } from "react";
import { ChromePicker } from "react-color";
import CanvasStage from "./CanvasStage";
export default function TemplateEditor({
    open,
    asset,
    onClose,
    onSave
}) {

    const defaultConfig = {
    layers: [
        {
            id: Date.now().toString(),
            text: "",
            x: 50,
            y: 60,
            fontFamily: "Arial",
            fontSize: 48,
            color: "#ffffff",
            bold: false,
            italic: false,
            align: "center",

            shadow: {
                enabled: false,
                color: "#000000",
                blur: 5,
                offsetX: 4,
                offsetY: 4,
                opacity: 0.6
            },

            stroke: {
                enabled: false,
                color: "#000000",
                width: 2
            },

            background: {
                enabled: false,
                color: "#ff0000",
                padding: 10,
                radius: 6
            }
        }
    ]
};

    const [config, setConfig] = useState(defaultConfig);
    const [selectedLayerId, setSelectedLayerId] = useState(null);
    const selectedLayer =
    config.layers?.find(
        layer => layer.id === selectedLayerId
    ) || config.layers?.[0];
    const stageRef = useRef(null);
    useEffect(() => {

        if (!asset) return;

        if (asset.overlay_config) {

            try {

                const loaded = JSON.parse(asset.overlay_config);

if (!loaded.layers) {
    loaded.layers = [
        {
            ...defaultConfig.layers[0],
            ...loaded
        }
    ];
}

setConfig(loaded);

setSelectedLayerId(loaded.layers[0]?.id || null);

            } catch {

                setConfig({
    layers: [
        {
            ...defaultConfig.layers[0],
            text: asset.overlay_text || ""
        }
    ]
});

setSelectedLayerId(defaultConfig.layers[0].id);

            }

        } else {

            setConfig({
    layers: [
        {
            ...defaultConfig.layers[0],
            text: asset.overlay_text || ""
        }
    ]
});

setSelectedLayerId(defaultConfig.layers[0].id);

        }

    }, [asset]);

    if (!open) return null;

    return (

        <div className="template-editor-overlay">

            <div className="template-editor">

                <div className="template-preview">
    <CanvasStage
        ref={stageRef}
        asset={asset}
        config={config}
        setConfig={setConfig}
        selectedLayerId={selectedLayerId}
        onSelectLayer={setSelectedLayerId}
    />
</div>

<div className="layer-panel">

    <div className="layer-header">
        Layers
    </div>

    <div className="layer-toolbar">

        <button
            onClick={() => {

                const newLayer = {

                    ...defaultConfig.layers[0],

                    id: Date.now().toString(),

                    text: "New Text",

                    x: 50,

                    y: 50

                };

                setConfig(prev => ({
                    ...prev,
                    layers: [...prev.layers, newLayer]
                }));

                setSelectedLayerId(newLayer.id);

                setTimeout(() => {
                    stageRef.current?.select(newLayer.id);
                }, 0);

            }}
        >
            + Add Text
        </button>

    </div>

    <div className="layer-list">

        {config.layers.map(layer => (

            <div
                key={layer.id}
                className={
                    layer.id === selectedLayerId
                        ? "layer-item active"
                        : "layer-item"
                }
                onClick={() => {

                    setSelectedLayerId(layer.id);

                    stageRef.current?.select(layer.id);

                }}
            >
                📝 {layer.text || "Untitled"}
            </div>

        ))}

    </div>

</div>
                <div className="template-controls">
                    <div className="controls-header">

        Template Editor

    </div>
                        <div className="controls-body">

                    <input
                        value={selectedLayer?.text || ""}
                        onChange={(e) =>
    setConfig(prev => ({
        ...prev,
        layers: prev.layers.map(layer =>
            layer.id === selectedLayerId
                ? {
                      ...layer,
                      text: e.target.value
                  }
                : layer
        )
    }))
}
                    />

                    <input
                        type="number"
                        value={selectedLayer?.fontSize || 48}
                        onChange={(e)=>
                            setConfig(prev => ({
    ...prev,
    layers: prev.layers.map(layer =>
        layer.id === selectedLayerId
            ? {
                  ...layer,
                  fontSize:Number(e.target.value)
              }
            : layer
    )
}))
                        }
                    />

                    <ChromePicker
                        color={selectedLayer?.color}
                        onChange={(c)=>
                            setConfig(prev => ({
    ...prev,
    layers: prev.layers.map(layer =>
        layer.id === selectedLayerId
            ? {
                  ...layer,
                  color:c.hex
              }
            : layer
    )
}))
                        }
                    />

                    <label>

                        <input
                            type="checkbox"
                            checked={selectedLayer?.bold || false}
                            onChange={(e)=>
                                setConfig(prev => ({
    ...prev,
    layers: prev.layers.map(layer =>
        layer.id === selectedLayerId
            ? {
                  ...layer,
                  bold:e.target.checked
              }
            : layer
    )
}))
                            }
                        />

                        Bold

                    </label>

                    <label>

                        <input
                            type="checkbox"
                            checked={selectedLayer?.italic || false}
                            onChange={(e)=>
                                setConfig(prev => ({
    ...prev,
    layers: prev.layers.map(layer =>
        layer.id === selectedLayerId
            ? {
                  ...layer,
                  italic:e.target.checked
              }
            : layer
    )
}))
                            }
                        />

                        Italic

                    </label>
<hr />

<h3>Shadow</h3>

<label>
    <input
        type="checkbox"
        checked={selectedLayer?.shadow?.enabled || false}
        onChange={(e)=>
            setConfig(prev => ({
    ...prev,
    layers: prev.layers.map(layer =>
        layer.id === selectedLayerId
            ? {
                  ...layer,
                  shadow:{
                      ...layer.shadow,
                      enabled:e.target.checked
                  }
              }
            : layer
    )
}))
        }
    />
    Enable Shadow
</label>

<p>Blur</p>

<input
    type="range"
    min="0"
    max="30"
    value={selectedLayer?.shadow?.blur || 5}
    onChange={(e)=>

    setConfig(prev => ({

        ...prev,

        layers: prev.layers.map(layer =>

            layer.id === selectedLayerId

                ? {

                      ...layer,

                      shadow:{

                          ...layer.shadow,

                          blur:Number(e.target.value)

                      }

                  }

                : layer

        )

    }))

}
/>

<p>Offset X</p>

<input
    type="range"
    min="-30"
    max="30"
    value={selectedLayer?.shadow?.offsetX || 0}
    onChange={(e)=>
    setConfig(prev => ({
        ...prev,
        layers: prev.layers.map(layer =>
            layer.id === selectedLayerId
                ? {
                      ...layer,
                      shadow:{
                          ...layer.shadow,
                          offsetX:Number(e.target.value)
                      }
                  }
                : layer
        )
    }))
}
/>

<p>Offset Y</p>

<input
    type="range"
    min="-30"
    max="30"
    value={selectedLayer?.shadow?.offsetY || 0}
   onChange={(e)=>
    setConfig(prev => ({
        ...prev,
        layers: prev.layers.map(layer =>
            layer.id === selectedLayerId
                ? {
                      ...layer,
                      shadow:{
                          ...layer.shadow,
                          offsetY:Number(e.target.value)
                      }
                  }
                : layer
        )
    }))
}
/>

<p>Opacity</p>

<input
    type="range"
    min="0"
    max="1"
    step="0.05"
    value={selectedLayer?.shadow?.opacity || 1}
    onChange={(e)=>
    setConfig(prev => ({
        ...prev,
        layers: prev.layers.map(layer =>
            layer.id === selectedLayerId
                ? {
                      ...layer,
                      shadow:{
                          ...layer.shadow,
                          opacity:Number(e.target.value)
                      }
                  }
                : layer
        )
    }))
}
/>

<p>Shadow Color</p>

<ChromePicker
    color={selectedLayer?.shadow?.color || "#000000"}
    onChange={(c)=>
    setConfig(prev => ({
        ...prev,
        layers: prev.layers.map(layer =>
            layer.id === selectedLayerId
                ? {
                      ...layer,
                      shadow:{
                          ...layer.shadow,
                          color:c.hex
                      }
                  }
                : layer
        )
    }))
}
/>
</div>
<div className="controls-footer">
<button
onClick={() => {

    if(config.layers.length===1) return;

    const layers=config.layers.filter(
        l=>l.id!==selectedLayerId
    );

    setConfig({
        ...config,
        layers
    });

    setSelectedLayerId(layers[0].id);

setTimeout(() => {
    stageRef.current?.select(layers[0].id);
}, 0);

}}
>
Delete Layer
</button>
<button
onClick={() => {

    const current=config.layers.find(
        l=>l.id===selectedLayerId
    );

    const copy={
        ...current,
        id:Date.now().toString(),
        x:current.x+5,
        y:current.y+5
    };

    setConfig({
        ...config,
        layers:[
            ...config.layers,
            copy
        ]
    });

    setSelectedLayerId(copy.id);

setTimeout(() => {
    stageRef.current?.select(copy.id);
}, 0);

}}
>
Duplicate Layer
</button>
                    <button
onClick={async () => {

    const editor = stageRef.current;
 
    if (!editor || !editor.stage) {
        alert("Stage not found");
        return;
    }

    const {
    stage,
    imageRect,
    originalWidth
} = editor;

if (
    !stage ||
    !imageRect.width ||
    !originalWidth
) {
    alert("Image is not ready yet.");
    return;
}

const pixelRatio = originalWidth / imageRect.width;
stageRef.current.deselect();
stage.batchDraw();
await new Promise(resolve => requestAnimationFrame(resolve));
await new Promise(resolve => requestAnimationFrame(resolve));
const dataURL = stage.toDataURL({
    x: imageRect.x,
    y: imageRect.y,
    width: imageRect.width,
    height: imageRect.height,
    pixelRatio
});

    const blob = await (await fetch(dataURL)).blob();

    await onSave(config, blob);

    alert("Template saved successfully!");

}}
>
    Save
</button>

                    <button onClick={onClose}>
                        Close
                    </button>
                    </div>


                </div>

            </div>

        </div>    
    
    );

}